module.exports = __webpack_public_path__ + "img/cites.1a48dc38.jpeg";